import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { UserPublic } from '@masamune/shared';

interface AuthState {
  user: UserPublic | null;
  realUser: UserPublic | null; // backup quando si attiva demo role
  accessToken: string | null;
  demoActive: boolean;
  setAuth: (user: UserPublic, accessToken: string) => void;
  setDemoRole: (roleData: UserPublic['role'], permissions: UserPublic['permissions']) => void;
  clearDemoRole: () => void;
  clear: () => void;
  isAuthenticated: () => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      realUser: null,
      accessToken: null,
      demoActive: false,
      setAuth: (user, accessToken) => set({ user, accessToken, realUser: null, demoActive: false }),
      setDemoRole: (roleData, permissions) => {
        const cur = get().user;
        if (!cur) return;
        const realUser = get().realUser ?? cur;
        set({
          realUser,
          user: { ...cur, role: roleData, permissions },
          demoActive: true,
        });
      },
      clearDemoRole: () => {
        const real = get().realUser;
        if (real) set({ user: real, realUser: null, demoActive: false });
      },
      clear: () => set({ user: null, realUser: null, accessToken: null, demoActive: false }),
      isAuthenticated: () => !!get().accessToken && !!get().user,
    }),
    {
      name: 'msm-auth',
      // Persistiamo solo il "vero" utente e il token. Il demo role è volatile per sessione:
      // se l'utente ricarica la pagina mentre era in modalità demo, ripartiamo dal ruolo reale.
      partialize: (state) => ({
        user: state.demoActive && state.realUser ? state.realUser : state.user,
        accessToken: state.accessToken,
      }),
    },
  ),
);
